import translations from './translations'

translations.add('es', {
    mainDescription: 'El pago está siendo procesado',
    tokenizationDescription: 'Registro de tarjeta en curso',
    verificationDescription: 'Verificación de tarjeta en curso',
    secondaryDescription: 'Espere, no cierre ni actualice la página'
})
